import { useMemo } from 'react';
import { Typography } from '@mui/material';

import { AccessRequestClientModel, ClientChallengeLogicalRelation, ClientChallengeStatus } from '@client-app-sdk';

import MoreTexts from './MoreTexts';

export default function ChallengeCell({ challenge }: Pick<AccessRequestClientModel, 'challenge'>) {
  const approversNames = useMemo(() => challenge?.approvers.map((approver) => approver.name), [challenge?.approvers]);

  const prefix = useMemo(() => {
    for (const approver of challenge?.approvers || []) {
      switch (approver.status) {
        case ClientChallengeStatus.Pending:
          return (
            <Typography variant="inputLabel" color="text.muted" component="span">
              Pending
            </Typography>
          );
        case ClientChallengeStatus.Rejected:
          return (
            <Typography variant="inputLabel" color="text.muted" component="span">
              Rejected by
            </Typography>
          );
      }
    }

    return (
      <Typography variant="inputLabel" color="text.muted" component="span">
        Approved by
      </Typography>
    );
  }, [challenge?.approvers]);

  if (!challenge || !approversNames || approversNames.length === 0) {
    return (
      <Typography variant="inputLabel" color="text.muted" component="p">
        Auto-approval
      </Typography>
    );
  }

  return (
    <MoreTexts
      texts={approversNames}
      isOr={challenge.logical_relation === ClientChallengeLogicalRelation.AnyOf}
      prefix={prefix}
    />
  );
}
